import 'twin.macro';

import { ProfileInfoBoxProps } from './type';

const ProfileInfoBox = ({ label, value }: ProfileInfoBoxProps) => {
  if (!value) return null;

  return (
    <div tw="p-4 bg-gray-50 rounded-lg border border-gray-200 flex flex-col gap-1 w-full justify-center items-center">
      <p tw="font-medium">{label}</p>
      {value.startsWith('https') ? (
        <a tw="underline break-all" href={`${value}`}>
          {value}
        </a>
      ) : (
        <p tw="font-light">{value}</p>
      )}
    </div>
  );
};

export default ProfileInfoBox;
